module.exports = __webpack_public_path__ + "static/img/no-logistics.dcbde54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/express/no-logistics.png
// module id = FpLa
// module chunks = 73